import React, { useState } from "react";
import Header from "./components/Header";
import Footer from "./components/Footer";
import RadioPlayer from "./components/RadioPlayer";
import AboutUs from "./components/AboutUs";
import Contact from "./components/Contact";
import Programas from "./components/Programas";
import "./App.css";

function App() {
  const [isAboutVisible, setIsAboutVisible] = useState(false);
  const [isContactVisible, setIsContactVisible] = useState(false);
  const [isProgramasVisible, setIsProgramasVisible] = useState(false);

  const handleAboutOpen = () => {
    setIsAboutVisible(true);
  };

  const handleAboutClose = () => {
    setIsAboutVisible(false);
  };

  const handleContactOpen = () => {
    setIsContactVisible(true);
  };

  const handleContactClose = () => {
    setIsContactVisible(false);
  };

  const handleProgramasOpen = () => {
    setIsProgramasVisible(true);
  };

  const handleProgramasClose = () => {
    setIsProgramasVisible(false);
  };

  return (
    <div className="app">
      <div className="background"></div>
      <Header 
        onAboutOpen={handleAboutOpen} 
        onContactOpen={handleContactOpen} 
        onProgramasOpen={handleProgramasOpen}
      />
      <main>
        <RadioPlayer />
      </main>
      <Footer />
      {isAboutVisible && <AboutUs onClose={handleAboutClose} />}
      {isContactVisible && <Contact onClose={handleContactClose} />}
      {isProgramasVisible && <Programas onClose={handleProgramasClose} />}
    </div>
  );
}

export default App;
